import { render, staticRenderFns } from "./TwoColumnBlock.vue?vue&type=template&id=c47049da"
import script from "./TwoColumnBlock.vue?vue&type=script&lang=js"
export * from "./TwoColumnBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports